import { z } from 'zod/v4'
import { PlatformShortcode } from '@/utils/convert-platform'

export interface BatchUnlockKolRequest {
  uuids: string[]
  from?: string
}

const unlockedKolSchema = z.object({
  uuid: z.uuid(),
  name: z.string().min(1),
})

export const batchUnlockKolResponseSchema = z.object({
  unlock_success_list: unlockedKolSchema.array(),
  unlock_failure_list: unlockedKolSchema.array(),
})
export type BatchUnlockKolResponse = z.infer<
  typeof batchUnlockKolResponseSchema
>

export enum StatisticStatusValue {
  NotCalculated = 0,
  Calculating = 1,
  InsufficientData = 2,
  ZeroData = 3,
  SufficientData = 4,
}

const statisticStatusValueSchema = z.enum(StatisticStatusValue)

const platformSpecificStatisticStatusSchema = z.object({
  platform: z.enum(PlatformShortcode),
  status: statisticStatusValueSchema,
})

const availableUnlockDataNameSchema = z.enum([
  'audience',
  'customized_tag',
  'engagement',
  'fans_growth',
  'hashtag_analysis',
  'k_score',
  'mention_brand_kol',
  'overview',
  'post_frequency',
  'similar_kol',
  'view_analysis',
  'sponsored_post_analysis',
])
export type AvailableUnlockDataName = z.infer<
  typeof availableUnlockDataNameSchema
>

export const availableUnlockDataSchema = z.object({
  name: availableUnlockDataNameSchema,
  status: z.union([
    statisticStatusValueSchema,
    platformSpecificStatisticStatusSchema.array(),
  ]),
})
export type AvailableUnlockData = z.infer<typeof availableUnlockDataSchema>

export const fetchAvailableUnlockDataResponseSchema = z.object({
  data: z.object({
    statistics_status: availableUnlockDataSchema.array(),
  }),
})
export type FetchAvailableUnlockDataResponse = z.infer<
  typeof fetchAvailableUnlockDataResponseSchema
>

export interface FetchAvailableUnlockDataRequest {
  kolId: string
}
